export default "__VITE_ASSET__DgbZza96__"